// Vehicles Factories
import VehicleEntitiesFactory from '../Entities/factory.js'
import {VehiclesMappersFactory} from '../Mappers/factory.js'
import VehiclesRepositoriesFactory from '../Repositories/factory.js'
// Vehicles Services
import {GetCompetitorsVehiclesService} from './GetCompetitorsVehiclesService.js'
import {GetSpecsVehicleService} from './GetSpecsVehicleService.js'
import {GetSubscriptionModelsVehiclesService} from './GetSubscriptionModelsVehiclesService.js'
import {GetVehicleInfoVehiclesService} from './GetVehicleInfoVehiclesService.js'
import {GetVehiclesInfoByPlateVehiclesService} from './GetVehiclesInfoByPlateVehiclesService.js'
export class VehiclesServicesFactory {
  static getCompetitorsVehiclesService = ({config}) => {
    return new GetCompetitorsVehiclesService({
      config,
      httpVehiclesRepository: VehiclesRepositoriesFactory.httpVehiclesRepository({
        config
      })
    })
  }

  static getSubscriptionModelsVehiclesService = ({config}) => {
    return new GetSubscriptionModelsVehiclesService({
      config,
      httpVehiclesRepository: VehiclesRepositoriesFactory.httpVehiclesRepository({
        config
      })
    })
  }

  static getVehiclesInfoByPlateVehiclesService = ({config}) =>
    new GetVehiclesInfoByPlateVehiclesService({
      httpVehiclesRepository: VehiclesRepositoriesFactory.httpVehiclesRepository({
        config
      }),
      vehicleEntityFactory: VehicleEntitiesFactory.vehicleEntity
    })

  static getSpecsVehicleService = ({config}) => {
    return new GetSpecsVehicleService({
      mapper: VehiclesMappersFactory.fromSpecsParamsToSearchUrlValueObjectMapper({config}),
      repository: VehiclesRepositoriesFactory.httpVehiclesRepository({config})
    })
  }

  static getVehicleInfoVehiclesService = ({config}) => {
    return new GetVehicleInfoVehiclesService({
      config,
      getCompetitorsVehiclesService: this.getCompetitorsVehiclesService({
        config
      }),
      httpVehiclesRepository: VehiclesRepositoriesFactory.httpVehiclesRepository({
        config
      }),
      fromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper:
        VehiclesMappersFactory.fromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper({config}),
      vehicleEntityFactory: VehicleEntitiesFactory.vehicleEntity
    })
  }
}
